import { useQuery } from "@tanstack/react-query";

import { useSearchDemoMode } from "app/pages/sales-intelligence/modules/leads-search/hooks/useSearchDemoMode";
import type {
    LeadsSearchRequestDto,
    LeadsSearchResponseDto,
    LeadsType,
} from "app/pages/sales-intelligence/modules/leads-search/types";
import { useListParams } from "app/pages/sales-intelligence/modules/lists/context/ListParamsContext";

import { createLeadsSearchResultsQuery } from "./options";

export function useLeadsSearchResultsQuery<T = LeadsSearchResponseDto>(
    leadsType: LeadsType,
    dto: LeadsSearchRequestDto,
    isEnabled: boolean,
    select?: (data: LeadsSearchResponseDto) => T,
) {
    const listParams = useListParams();
    const demoMode = useSearchDemoMode();

    return useQuery(
        createLeadsSearchResultsQuery<T>({
            leadsType,
            dto,
            listParams,
            select,
            demoMode,
            enabled: isEnabled,
        }),
    );
}
